
import { Card } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Laptop, Smartphone } from "lucide-react";
import { FunnelForm } from "./FunnelForm";
import { Preview } from "./Preview";
import type { FunnelData } from "./types";

interface MobileBuilderProps {
  funnelData: FunnelData;
  selectedPageId: string | null;
  onUpdate: (data: FunnelData) => void;
  onPageSelect: (pageId: string) => void;
  handleImageUpload: (e: React.ChangeEvent<HTMLInputElement>, type: 'logo' | 'headerImage') => void;
}

export const MobileBuilder = ({
  funnelData,
  selectedPageId,
  onUpdate,
  onPageSelect,
  handleImageUpload
}: MobileBuilderProps) => {
  return (
    <Tabs defaultValue="editor" className="flex-1 px-4">
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="editor" className="flex items-center gap-2 rounded-full">
          <Laptop className="w-4 h-4" /> Szerkesztő
        </TabsTrigger>
        <TabsTrigger value="preview" className="flex items-center gap-2 rounded-full">
          <Smartphone className="w-4 h-4" /> Előnézet
        </TabsTrigger>
      </TabsList>
      <TabsContent value="editor" className="mt-4 h-[calc(100vh-12rem)]">
        <Card className="h-full bg-white/50 backdrop-blur-sm border-slate-200/60 shadow-sm hover:shadow-md transition-all duration-300">
          <div className="h-full overflow-auto p-4">
            <FunnelForm 
              onUpdate={onUpdate} 
              initialData={funnelData} 
              onPageSelect={onPageSelect}
              handleImageUpload={handleImageUpload}
            />
          </div>
        </Card>
      </TabsContent>
      <TabsContent value="preview" className="mt-4 h-[calc(100vh-12rem)]">
        <Card className="h-full bg-white/50 backdrop-blur-sm border-slate-200/60 shadow-sm hover:shadow-md transition-all duration-300">
          <Preview 
            data={funnelData} 
            currentPage={selectedPageId} 
            showAfterSubmit={false}
          />
        </Card>
      </TabsContent>
    </Tabs>
  );
};
